export default {
    'preferredExhibitors': '热门',
    'invitationNotifyTips' : '请添加员工',
    'tips' : '提示',
    'product': '浏览过的展品',
    'exhibitor': '浏览过的展商',
    'person': '浏览过的客商',
    'userAccountId': '环信id不能为空',
    'exhibitorNoline': '展商不在线'
  }
  